import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-12 md:mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="text-lg font-bold text-background-50">
                神马<span className="text-accent-400">视频</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              神马视频是集最新电影、电视剧、综艺节目于一体的多元影视内容平台，专注为影视爱好者提供全面的资源展示与信息导航，帮助你快速查找、浏览并了解影视内容。
            </p>
            <p className="mt-3 text-xs text-background-300">
              本站仅提供影视内容信息展示与导航，不提供视频播放及下载服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">分类导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  综艺
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">快捷入口</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索影视
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {year} 神马视频 · 多元影视资源平台 · 仅供学习演示使用</p>
          <p className="flex items-center gap-4">
            <span>资源展示 · 信息导航</span>
            <span className="hidden sm:inline">|</span>
            <span>无播放与下载功能</span>
          </p>
        </div>
      </div>
    </footer>
  );
}